export class FTE {
	constructor(
		public readonly value: number,
		public readonly precision: number) { }

	public static fromJson(o: any): FTE {
		return new FTE(o.value, o.precision);
	}
}
